import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/WhyWe.css";
import { CheckCircle } from "lucide-react"; // ✅ Import icon
import whyImg from "../img/why.jpg"; // ✅ Image path

const WhyWe = () => {
  const reasons = [
    {
      title: "Government Recognized",
      text: "Our institute is approved under ITI code PR33000105, ensuring a structured and certified training curriculum.",
    },
    {
      title: "NCVT Powered",
      text: "This Private ITI is under the Ministry of Skill Development and Entrepreneurship, Government of India — for the Craftsmen Training Scheme.",
    },
    {
      title: "Quality Training",
      text: "We focus on both theoretical knowledge and practical applications to provide industry-relevant training.",
    },
    {
      title: "Experienced Faculty",
      text: "Our team of skilled instructors is dedicated to guiding students toward technical excellence.",
    },
    {
      title: "Well-Equipped Infrastructure",
      text: "We provide modern labs and workshops with state-of-the-art equipment for hands-on learning.",
    },
    {
      title: "Career-Oriented Approach",
      text: "Our training ensures that students are job-ready and well-prepared for opportunities in the electrical industry.",
    },
  ];

  return (
    <section className="whywe-section py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Column */}
          <div className="col-lg-6 col-md-12 mb-4">
            <h2 className="fw-bold mb-4 text-dark">Why Choose Us?</h2>
            <ul className="list-unstyled">
              {reasons.map((item, index) => (
                <li key={index} className="d-flex align-items-start mb-3">
                  <CheckCircle className="text-primary me-3 icon-size" />
                  <div>
                    <strong>{item.title} –</strong>
                    <p className="mb-0">{item.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Column (Image) */}
          <div className="col-lg-6 col-md-12 text-center">
            <img
              src={whyImg}
              alt="Why Choose Us"
              className="img-fluid rounded shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyWe;
